(function(){
'use strict';
function T(k, en) { var t = window.OS_T; return (t && typeof t[k] === "string" && t[k]) || en; }
/* T plus {name} placeholders, every occurrence. */
function F(k, en, v) { var s = T(k, en); for (var n in v) s = s.split('{' + n + '}').join(v[n]); return s; }
function boot(){
const R=document.getElementById('bt-root');
if(!R||R.dataset.btReady) return;
R.dataset.btReady='1';

/* ============ recipe ============ */
const RECIPE=[
  {kind:'pour', name:'Bloom',  label:T('brew_trainer.bloom','Bloom'),   add:49.9, dur:12},
  {kind:'wait',                add:0,    dur:18},
  {kind:'pour', name:'Pour 1', label:T('brew_trainer.pour_1','Pour 1'), add:75.9, dur:12},
  {kind:'wait',                add:0,    dur:18},
  {kind:'pour', name:'Pour 2', label:T('brew_trainer.pour_2','Pour 2'), add:99.2, dur:27},
  {kind:'wait',                add:0,    dur:33}
];
let acc=0, cum=0;
RECIPE.forEach(s=>{ s.t0=acc; acc+=s.dur; s.t1=acc; s.w0=cum; cum=+(cum+s.add).toFixed(1); s.w1=cum; });
const TOTAL_T=acc, TOTAL_W=cum;          // 120 s, 225.0 g
const MAXFLOW=10;
const LADDER=[20,50,100,150,200,250,300,400,500,600];

/* ============ icons ============ */
const ICO={
  bloom:'<svg viewBox="0 0 24 24"><path d="M12 3.4c2.35 2.1 3.5 4.1 3.5 6.05 0 2.3-1.6 3.9-3.5 3.9s-3.5-1.6-3.5-3.9C8.5 7.5 9.65 5.5 12 3.4z"/><path d="M11.1 13.1c-2.2-2.1-4.85-2.85-7.8-2.2.45 3.05 2.15 4.95 5.1 5.7 1.35.35 2.3.2 2.7-.25z"/><path d="M12.9 13.1c2.2-2.1 4.85-2.85 7.8-2.2-.45 3.05-2.15 4.95-5.1 5.7-1.35.35-2.3.2-2.7-.25z"/><path d="M12 15.4V21" fill="none" stroke-width="1.8" stroke-linecap="round"/></svg>',
  wait:'<svg viewBox="0 0 24 24"><path d="M5.6 3h12.8M5.6 21h12.8" stroke-width="2.2" stroke-linecap="round" fill="none"/><path d="M7.3 4.7h9.4c0 3.6-3.15 5.5-3.15 7.3s3.15 3.7 3.15 7.3H7.3c0-3.6 3.15-5.5 3.15-7.3S7.3 8.3 7.3 4.7z"/></svg>',
  pour:'<svg viewBox="0 0 26 22">'+
    '<path d="M5.5 9C3.2 7.7 2.3 6 3.4 4.8" fill="none" stroke-width="1.9" stroke-linecap="round"/>'+
    '<path d="M3.4 4.8L1 2.7" fill="none" stroke-width="2.9" stroke-linecap="round"/>'+
    '<path d="M14.4 14.4C18.4 13.7 20.7 11.9 21.9 9.3 22.5 7.9 24 7.7 24.6 8.8" '+
      'fill="none" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>'+
    '<path d="M8.2 6.5Q8.2 5.4 9.3 5.4H10.3Q11.4 5.4 11.4 6.5V7.6H13.9V9.5H13L16.4 17.5H17.1'+
      'Q17.9 17.5 17.9 18.3V18.9Q17.9 19.7 17.1 19.7H2.5Q1.7 19.7 1.7 18.9V18.3'+
      'Q1.7 17.5 2.5 17.5H3.2L6.6 9.5H5.7V7.6H8.2Z" stroke-width=".8" stroke-linejoin="round"/></svg>'
};
const stepIcon=s=>s.kind==='wait'?ICO.wait:(s.name==='Bloom'?ICO.bloom:ICO.pour);
const stepLabel=s=>s.kind==='wait'?T('brew_trainer.wait_until','Wait until'):F('brew_trainer.pour_until','{name} {g}g until',{name:s.label,g:s.add.toFixed(1)});
const stepNow=s=>F('brew_trainer.pour_now','{name} {g}g',{name:s.label,g:s.add.toFixed(1)});
const mmss=x=>{x=Math.max(0,x);const m=Math.floor(x/60),s=Math.floor(x%60);return m+':'+String(s).padStart(2,'0');};

/* ============ dom ============ */
const $=id=>R.querySelector('#bt-'+id);
const cv=$('cv'), ctx=cv.getContext('2d');
const pz=$('pz');
const kettle=$('kettle'), kTilt=$('kettleTilt'), stream=$('stream');
const pool=$('pool'), poolTop=$('poolTop'), bed=$('bed'), carafeFill=$('carafeFill'),
      bubbles=$('bubbles'), drip=$('drip'), drops=$('drops');

/* ============ state ============ */
const S={running:false,done:false,t:0,w:0,flow:0,pouring:false,ptrY:0,hist:[],last:0,started:false,
  showF:true,showW:true,poolL:0,carafeL:0,bedSwell:0,drainRate:0,
  waterTop:223,lockUntil:0,cw:0,ch:0};

/* ============ canvas sizing ============ */
function sizeCanvas(){
  const r=cv.getBoundingClientRect(), d=Math.min(2,window.devicePixelRatio||1);
  if(!r.width||!r.height) return;
  cv.width=Math.round(r.width*d); cv.height=Math.round(r.height*d);
  ctx.setTransform(d,0,0,d,0,0); S.cw=r.width; S.ch=r.height;
}
let rz; const onRz=()=>{ if(!R.isConnected){ window.removeEventListener('resize',onRz); return; } clearTimeout(rz); rz=setTimeout(sizeCanvas,90); };
window.addEventListener('resize',onRz);
if(window.ResizeObserver) new ResizeObserver(()=>sizeCanvas()).observe(cv.parentNode);

const stepAt=t=>{for(let i=0;i<RECIPE.length;i++) if(t<RECIPE[i].t1) return i; return RECIPE.length-1;};
const axisMax=w=>{for(const v of LADDER) if(w<=v*0.999) return v; return LADDER[LADDER.length-1];};

/* ============ step cards ============ */
let lastStep=-1;
function renderSteps(i){
  if(i===lastStep) return; lastStep=i;
  const cur=RECIPE[i], nxt=RECIPE[i+1], rows=[];
  rows.push(`<div class="bt-step bt-cur"><span class="bt-ico">${stepIcon(cur)}</span><span class="bt-lbl">${stepLabel(cur)}</span><span class="bt-tm bt-num">${mmss(cur.t1)}</span></div>`);
  if(nxt) rows.push(`<div class="bt-step bt-nxt"><span class="bt-ico">${stepIcon(nxt)}</span><span class="bt-lbl">${stepLabel(nxt)}</span><span class="bt-tm bt-num">${mmss(nxt.t1)}</span></div>`);
  $('steps').innerHTML=rows.join('');
  R.querySelectorAll('#bt-recipeStrip .bt-rchip').forEach((c,k)=>c.classList.toggle('bt-on',k===i));
}
$('recipeStrip').innerHTML=RECIPE.map(s=>
  `<span class="bt-rchip">${s.kind==='wait'?T('brew_trainer.rest_chip','rest'):s.label} · ${s.kind==='wait'?s.dur+'s':s.add.toFixed(1)+'g / '+s.dur+'s'}</span>`).join('');

/* ============ axes ============ */
let axKey='',wKey=-1;
function renderTimeAxis(st){
  const key=st.t0+'|'+st.t1; if(key===axKey) return; axKey=key;
  const iv=Math.max(1,Math.floor(st.dur/4)); let h=`<span class="bt-top bt-num" style="top:2%">${mmss(st.t1)}</span>`;
  for(let tv=st.t0;tv<st.t1-iv*0.4;tv+=iv){
    const p=100-((tv-st.t0)/st.dur)*100;
    if(p>12&&p<=100) h+=`<span class="bt-num" style="top:${p}%">${mmss(tv)}</span>`;
  }
  $('taxis').innerHTML=h;
}
function renderWTicks(mx){
  if(mx===wKey) return; wKey=mx;
  let h=''; for(let k=0;k<=5;k++) h+=`<span>${Math.round(mx*k/5)}</span>`;
  $('wticks').innerHTML=h;
}
$('fticks').innerHTML=[0,2,4,6,8,10].map(v=>`<span>${v}</span>`).join('');

/* ============ chart ============ */
function draw(){
  const W=S.cw,H=S.ch; if(!W||!H){sizeCanvas();return;}
  const st=RECIPE[stepAt(Math.min(S.t,TOTAL_T-0.001))];
  const mx=axisMax(Math.max(S.w,4)); renderWTicks(mx);
  const T2Y=t=>H-((t-st.t0)/st.dur)*H;
  const W2X=w=>(w/mx)*W, F2X=f=>(f/MAXFLOW)*W;

  ctx.clearRect(0,0,W,H);
  ctx.strokeStyle='rgba(255,255,255,.3)'; ctx.lineWidth=1;
  ctx.beginPath(); ctx.moveTo(.5,0); ctx.lineTo(.5,H-.5); ctx.lineTo(W,H-.5); ctx.stroke();

  const h=S.hist, lw=Math.max(2,Math.min(3.6,W*0.013));
  if(h.length>1){
    ctx.lineJoin='round'; ctx.lineCap='round'; ctx.lineWidth=lw;
    const series=[[S.showF,'#A493DA',p=>F2X(Math.min(p.f,MAXFLOW))],
                  [S.showW,'#FBCF57',p=>W2X(Math.min(p.w,mx))]];
    for(const [on,col,fx] of series){
      if(!on) continue;
      ctx.strokeStyle=col; ctx.beginPath(); let go=false;
      for(let k=0;k<h.length;k++){ const p=h[k];
        if(p.t<st.t0-0.5||p.t>st.t1) continue;
        const X=fx(p),Y=T2Y(p.t); go?ctx.lineTo(X,Y):(ctx.moveTo(X,Y),go=true);
      }
      ctx.stroke();
    }
  }
  const ty=Math.round(T2Y(Math.min(S.t,st.t1)))+.5;
  ctx.strokeStyle='rgba(255,255,255,.55)'; ctx.lineWidth=1;
  ctx.beginPath(); ctx.moveTo(0,ty); ctx.lineTo(W,ty); ctx.stroke();
}

/* ============ right bar ============ */
function updateBar(){
  const i=stepAt(Math.min(S.t,TOTAL_T-0.001)), st=RECIPE[i];
  let pct,cap;
  if(st.kind==='wait'){ pct=100; cap=S.w.toFixed(1)+'g'; }
  else { pct=Math.max(0,Math.min(100,((S.w-st.w0)/(st.w1-st.w0))*100)); cap=st.w1.toFixed(1)+'g'; }
  $('fill').style.height=pct+'%';
  $('chip').style.bottom=Math.max(4.5,pct)+'%';
  $('chip').textContent=(S.w<10?S.w.toFixed(1):S.w.toFixed(1))+'g';
  $('barcap').textContent=cap;
  const pm=$('pourmark');
  pm.style.opacity=(st.kind==='pour'&&S.started&&!S.done)?1:0;
  $('pourno').textContent=RECIPE.slice(0,i+1).filter(s=>s.kind==='pour').length;
}

/* ============ pour control ============ */
function bandY(clientY){
  const r=pz.getBoundingClientRect();
  const top=r.top+Math.min(48,r.height*0.17), bot=r.bottom-Math.min(20,r.height*0.07);
  return Math.max(0,Math.min(1,1-(clientY-top)/Math.max(1,bot-top)));
}
function down(e){
  if(S.done) return;
  if(e.pointerId!==undefined&&pz.setPointerCapture) try{pz.setPointerCapture(e.pointerId);}catch(_){}
  S.pouring=true; pz.classList.add('bt-pouring'); $('tapcue').classList.add('bt-hidden');
  if(e.clientY!==undefined) S.ptrY=bandY(e.clientY);
  if(!S.started){ S.started=true; S.running=true; S.last=performance.now(); try{ window.osTrack&&window.osTrack('pour_trainer_start',{}); }catch(e){} startLoop(); }
  if(e.preventDefault) e.preventDefault();
}
function move(e){ if(!S.pouring) return; S.ptrY=bandY(e.clientY); e.preventDefault(); }
function up(){ S.pouring=false; pz.classList.remove('bt-pouring'); }
pz.addEventListener('pointerdown',down);
pz.addEventListener('pointermove',move);
window.addEventListener('pointerup',up);
window.addEventListener('pointercancel',up);
pz.addEventListener('contextmenu',e=>e.preventDefault());
let btHover=false;
pz.addEventListener('pointerenter',()=>btHover=true);
pz.addEventListener('pointerleave',()=>btHover=false);
window.addEventListener('keydown',e=>{
  if(!btHover&&!S.pouring) return;
  if(e.code==='Space'&&!e.repeat){ if(!S.pouring&&!S.ptrY) S.ptrY=.45; down({}); e.preventDefault(); }
  else if(e.code==='ArrowUp'){ S.ptrY=Math.min(1,S.ptrY+.05); e.preventDefault(); }
  else if(e.code==='ArrowDown'){ S.ptrY=Math.max(0,S.ptrY-.05); e.preventDefault(); }
});
window.addEventListener('keyup',e=>{ if(e.code==='Space') up(); });

/* ============ scene ============ */
const CONE_TOP=188, CONE_BOT=234, CONE_HW=32;
const BED_DRY=223.5, BED_WET=214.5;               // grounds surface: dry -> fully bloomed
const HW=y=>CONE_HW*(CONE_BOT-y)/(CONE_BOT-CONE_TOP);   // cone half-width at any depth

const bubblePool=[];
for(let k=0;k<8;k++){
  const c=document.createElementNS('http://www.w3.org/2000/svg','circle');
  c.setAttribute('fill','#D3B693'); c.setAttribute('opacity','0'); c.setAttribute('r','1.5');
  bubbles.appendChild(c); bubblePool.push({el:c,life:0,x:150,y:BED_DRY,r:1.2});
}
const dropPool=[];
for(let k=0;k<5;k++){
  const c=document.createElementNS('http://www.w3.org/2000/svg','ellipse');
  c.setAttribute('cx','150'); c.setAttribute('rx','1.1'); c.setAttribute('ry','1.8');
  c.setAttribute('fill','#7A4A28'); c.setAttribute('opacity','0');
  drops.appendChild(c); dropPool.push({el:c,life:0,y:236});
}

function updateScene(dt,now){
  const f=S.flow;

  /* ---- the bed swells as it wets, settles once the bloom is over ---- */
  const want = S.t<34 ? Math.min(1,S.w/40) : Math.max(0,1-(S.t-34)/12);
  S.bedSwell += (Math.max(0,Math.min(1,want))-S.bedSwell)*Math.min(1,dt*1.8);
  const bedTop = BED_DRY-(BED_DRY-BED_WET)*S.bedSwell;
  const bw = HW(bedTop);
  bed.setAttribute('d',`M${(150-bw).toFixed(1)} ${bedTop.toFixed(1)} Q150 ${(bedTop-1.7).toFixed(1)} `+
    `${(150+bw).toFixed(1)} ${bedTop.toFixed(1)} L151.8 ${CONE_BOT} H148.2 Z`);

  /* ---- water in, water down ---- */
  S.poolL += f*dt;
  const drain = Math.min(S.poolL,(0.55+S.poolL*0.5)*dt);
  S.poolL -= drain; S.carafeL += drain;
  S.drainRate += ((dt>0?drain/dt:0)-S.drainRate)*Math.min(1,dt*5);

  const depth = Math.max(0,Math.min(bedTop-(CONE_TOP+2), S.poolL*1.25));
  const waterTop = bedTop-depth;
  S.waterTop = waterTop;
  if(depth>0.5){
    const ww=HW(waterTop);
    pool.setAttribute('d',`M${(150-ww).toFixed(1)} ${waterTop.toFixed(1)} L${(150+ww).toFixed(1)} ${waterTop.toFixed(1)} `+
      `L${(150+bw).toFixed(1)} ${bedTop.toFixed(1)} L${(150-bw).toFixed(1)} ${bedTop.toFixed(1)} Z`);
    pool.setAttribute('opacity','.6');
    poolTop.setAttribute('d',`M${(150-ww).toFixed(1)} ${waterTop.toFixed(1)} L${(150+ww).toFixed(1)} ${waterTop.toFixed(1)}`);
    poolTop.setAttribute('opacity','.55');
  }else{ pool.setAttribute('opacity',0); poolTop.setAttribute('opacity',0); }

  /* ---- kettle + pour stream, landing on whatever surface is there ---- */
  const ky=62+(1-S.ptrY)*90;
  kettle.setAttribute('transform','translate(150,'+ky.toFixed(1)+')');
  kTilt.setAttribute('transform','rotate('+(25+(S.flow/MAXFLOW)*11).toFixed(2)+' 0 0)');
  if(f>0.08){
    const wt=1.7+f*0.62, wb=wt*0.6, y0=ky+1.5, y1=waterTop+1;
    const wob=Math.sin(now/85)*0.9, mid=y0+(y1-y0)*0.55;
    stream.setAttribute('d',
      `M${(150-wt/2).toFixed(1)},${y0.toFixed(1)} C${(150-wt/2+wob).toFixed(1)},${mid.toFixed(1)} ${(150-wb/2).toFixed(1)},${(y0+(y1-y0)*.82).toFixed(1)} ${(150-wb/2).toFixed(1)},${y1.toFixed(1)} `+
      `L${(150+wb/2).toFixed(1)},${y1.toFixed(1)} C${(150+wb/2).toFixed(1)},${(y0+(y1-y0)*.82).toFixed(1)} ${(150+wt/2+wob).toFixed(1)},${mid.toFixed(1)} ${(150+wt/2).toFixed(1)},${y0.toFixed(1)} Z`);
    stream.setAttribute('opacity',Math.min(1,.5+f*.08).toFixed(2));
  } else stream.setAttribute('opacity',0);

  /* ---- brewed coffee arriving in the carafe ---- */
  const frac=Math.min(1,S.carafeL/TOTAL_W);
  const surf=282-frac*41;
  carafeFill.setAttribute('height',(frac*41).toFixed(1));
  carafeFill.setAttribute('y',surf.toFixed(1));

  const dr=S.drainRate;
  if(dr>0.9){                                   // running stream during drawdown
    const w=0.42+Math.min(dr,10)*0.085;
    drip.setAttribute('d',`M${(150-w).toFixed(2)} 234.5 L${(150-w*.68).toFixed(2)} ${surf.toFixed(1)} `+
      `L${(150+w*.68).toFixed(2)} ${surf.toFixed(1)} L${(150+w).toFixed(2)} 234.5 Z`);
    drip.setAttribute('opacity',Math.min(.8,.42+dr*.045).toFixed(2));
  } else drip.setAttribute('opacity',0);

  for(const d of dropPool){                     // discrete drips when it is only trickling
    if(d.life<=0){
      if(dr>0.03&&dr<=1.1&&Math.random()<dt*(4+dr*7)){ d.life=1; d.y=235.5; }
      else { d.el.setAttribute('opacity',0); continue; }
    }
    d.y += dt*118;
    if(d.y>=surf-1){ d.life=0; d.el.setAttribute('opacity',0); continue; }
    d.el.setAttribute('cy',d.y.toFixed(1));
    d.el.setAttribute('opacity','.85');
  }

  /* ---- CO2 off the bed while it blooms ---- */
  if(S.t<34&&S.running&&S.poolL>0.25){
    for(const b of bubblePool){
      if(b.life<=0){
        if(Math.random()<dt*5){ b.life=.9+Math.random()*.6;
          b.x=150+(Math.random()-.5)*bw*1.5; b.y=bedTop+.5; b.r=.8+Math.random()*1.1; }
        else { b.el.setAttribute('opacity',0); continue; }
      }
      b.life-=dt; b.y-=dt*7;
      b.el.setAttribute('cx',b.x.toFixed(1)); b.el.setAttribute('cy',b.y.toFixed(1));
      b.el.setAttribute('r',b.r.toFixed(1));
      b.el.setAttribute('opacity',Math.max(0,Math.min(.7,b.life)).toFixed(2));
    }
  } else for(const b of bubblePool){ if(b.life){b.life=0;b.el.setAttribute('opacity',0);} }

  $('knob').style.top=((1-S.ptrY)*100)+'%';
}

/* ============ loop ============ */
/* The loop only runs while the trainer is on screen or a brew is in
   progress, so an idle trainer further down the page costs nothing. */
let onScreen=true, looping=false;
function startLoop(){ if(looping) return; looping=true; S.last=0; requestAnimationFrame(tick); }
if(window.IntersectionObserver) new IntersectionObserver(es=>{ onScreen=es[es.length-1].isIntersecting; if(onScreen) startLoop(); },{rootMargin:'200px 0px'}).observe(R);
function tick(now){
  if(!R.isConnected){ looping=false; return; }            // section removed by the editor
  if(!onScreen && !S.running){ looping=false; return; }
  requestAnimationFrame(tick);
  if(!S.last) S.last=now;
  let dt=(now-S.last)/1000; S.last=now;
  if(dt>0.08) dt=0.08; if(dt<0) dt=0;

  const tgt=(S.pouring&&!S.done)?S.ptrY*MAXFLOW:0;
  S.flow+=(tgt-S.flow)*Math.min(1,dt*11);
  if(S.flow<0.03) S.flow=0;

  if(S.running){
    S.t+=dt; S.w+=S.flow*dt;
    const last=S.hist[S.hist.length-1];
    if(!last||S.t-last.t>=0.07) S.hist.push({t:S.t,w:S.w,f:S.flow});
    if(S.t>=TOTAL_T){ S.t=TOTAL_T; finish(); }
  }

  $('flowV').textContent=S.flow.toFixed(1);
  $('pzFlow').textContent=((S.pouring&&!S.done)?S.ptrY*MAXFLOW:S.flow).toFixed(1);
  $('bigClock').textContent=mmss(S.t);
  const st=RECIPE[stepAt(Math.min(S.t,TOTAL_T-0.001))];
  $('bigLbl').textContent=S.done?T('brew_trainer.recorded','recorded'):S.running?(st.kind==='wait'?T('brew_trainer.rest_stop','rest: stop pouring'):stepNow(st)):T('brew_trainer.ready','ready');
  renderSteps(stepAt(Math.min(S.t,TOTAL_T-0.001))); renderTimeAxis(st);
  draw(); updateBar(); updateScene(dt,now);
}
startLoop();

/* ============ ladder + date ============ */
(function(){ let h=''; for(let v=0;v<=10;v+=2) h+=`<span class="bt-tk bt-num" style="top:${100-v*10}%">${v}</span>`;
  $('ladder').insertAdjacentHTML('beforeend',h);
  const d=new Date();
  $('sbClock').textContent=(d.getHours()%12||12)+':'+String(d.getMinutes()).padStart(2,'0');
  $('recDate').textContent=(d.getMonth()+1)+'/'+d.getDate()+'/'+String(d.getFullYear()).slice(2);
})();

/* ============ buttons ============ */
function setPhase(done){
  for(const b of [$('stopBtn'),$('mStop')]){
    b.textContent = done?T('brew_trainer.brew_again','Brew again'):T('brew_trainer.stop','Stop');
    b.disabled=false; b.classList.toggle('bt-done',done);
  }
  $('results').hidden=!done; $('mResults').hidden=!done;
  $('tapcue').classList.toggle('bt-fin',done);
  if(done) $('tapcue').classList.remove('bt-hidden');
}
const openSheet=()=>{ if(S.done) $('sheet').classList.remove('bt-hidden'); };
const tog=(el,key)=>el.addEventListener('click',()=>{S[key]=!S[key];el.setAttribute('aria-pressed',S[key]);});
tog($('tgF'),'showF'); tog($('tgW'),'showW');
const stopOrRestart=()=>{
  if(S.done){ if(performance.now()>=S.lockUntil) reset(); }   // swallow a double-tap across the finish
  else if(S.started) finish();
};
$('stopBtn').addEventListener('click',stopOrRestart);
$('restart').addEventListener('click',reset);
$('mRestart').addEventListener('click',reset);
$('mStop').addEventListener('click',stopOrRestart);
$('results').addEventListener('click',openSheet);
$('mResults').addEventListener('click',openSheet);
$('sheet').addEventListener('click',e=>{ if(e.target===$('sheet')) $('sheet').classList.add('bt-hidden'); });
$('againBtn').addEventListener('click',()=>{$('sheet').classList.add('bt-hidden');reset();});
$('closeBtn').addEventListener('click',()=>$('sheet').classList.add('bt-hidden'));
/* Recipe shows and hides the recipe's steps beside the buttons, so
   the press always has a visible result. Restart is only live once a
   brew has started: before that there is nothing to restart. */
$('showRecipe').setAttribute('aria-pressed','false');
$('showRecipe').addEventListener('click',()=>{
  const on=$('showRecipe').getAttribute('aria-pressed')!=='true';
  $('showRecipe').setAttribute('aria-pressed',String(on));
  $('recipeStrip').classList.toggle('bt-open',on);
});
function syncRestart(){ const live=S.started||S.done; for(const b of [$('restart'),$('mRestart')]){ if(b.disabled===live) b.disabled=!live; } }
const syncTimer=setInterval(()=>{ if(!R.isConnected){ clearInterval(syncTimer); return; } syncRestart(); },200); syncRestart();

function reset(){
  Object.assign(S,{running:false,done:false,started:false,t:0,w:0,flow:0,pouring:false,
    hist:[],poolL:0,carafeL:0,bedSwell:0,drainRate:0,waterTop:223,lockUntil:0,last:0});
  lastStep=-1; axKey=''; wKey=-1;
  $('tapcue').classList.remove('bt-hidden'); $('sheet').classList.add('bt-hidden');
  setPhase(false); pz.classList.remove('bt-pouring');
  sizeCanvas();
}

/* ============ analysis ============ */
function wAt(t){
  const h=S.hist; if(!h.length) return 0;
  if(t<=h[0].t) return 0;
  for(let i=1;i<h.length;i++) if(h[i].t>=t){
    const a=h[i-1],b=h[i],k=(t-a.t)/Math.max(1e-4,b.t-a.t);
    return a.w+(b.w-a.w)*k;
  }
  return h[h.length-1].w;
}
function analyze(){
  return RECIPE.map(st=>{
    const reached=S.t>st.t0+0.5, complete=S.t>=st.t1-0.15;
    const seg=S.hist.filter(p=>p.t>=st.t0&&p.t<=st.t1);
    const actual=Math.max(0,wAt(Math.min(st.t1,S.t))-wAt(Math.min(st.t0,S.t)));
    const fl=seg.map(p=>p.f).filter(f=>f>0.2);
    const avg=fl.length?fl.reduce((a,b)=>a+b,0)/fl.length:0;
    const tgtFlow=st.add/st.dur;
    const errPct=st.add>0?((actual-st.add)/st.add)*100:0;
    return {st,actual,avg,tgtFlow,errPct,reached,complete};
  });
}
function tagFor(e){
  if(!e.reached) return ['t-n',T('brew_trainer.tag_not_reached','Not reached')];
  if(!e.complete) return ['t-b',T('brew_trainer.tag_cut_short','Cut short')];
  if(e.st.kind==='wait') return e.actual<=1.0?['t-a',T('brew_trainer.tag_clean','Clean')]:e.actual<=4?['t-b',T('brew_trainer.tag_leaked','Leaked')]:['t-c',T('brew_trainer.tag_poured','Poured')];
  const a=Math.abs(e.errPct);
  return a<=2?['t-a',T('brew_trainer.tag_dialed','Dialed')]:a<=5?['t-b',T('brew_trainer.tag_close','Close')]:a<=12?['t-c',T('brew_trainer.tag_off','Off')]:['t-c',T('brew_trainer.tag_way_off','Way off')];
}
function finish(){
  try{ if(!S.done) window.osTrack&&window.osTrack('pour_trainer_finish',{weight_g:Math.round(S.w),time_s:Math.round(S.t)}); }catch(e){}
  if(S.done) return;
  S.done=true; S.running=false; S.pouring=false; pz.classList.remove('bt-pouring');
  S.lockUntil=performance.now()+600;
  setPhase(true);
  const rows=analyze();
  const scored=rows.filter(e=>e.complete);
  let sc=0;
  for(const e of scored) sc+= e.st.kind==='pour'
      ? Math.max(0,100-Math.abs(e.errPct)*5)
      : Math.max(0,100-Math.min(100,Math.max(0,e.actual-0.8)*16));
  const finished=S.t>=TOTAL_T-0.2;
  const score=scored.length?Math.round(sc/scored.length):0;
  $('scoreNum').textContent=scored.length?score:'--';
  $('scoreWord').textContent=!scored.length?T('brew_trainer.score_none','stopped before the first step closed')
    :(score>=92?T('brew_trainer.score_repeatable','Repeatable'):score>=78?T('brew_trainer.score_nearly','Nearly there'):score>=60?T('brew_trainer.score_loose','Loose'):T('brew_trainer.score_scattered','Scattered'))+(finished?'':' · '+T('brew_trainer.partial_run','partial run'));
  $('sheetSub').textContent=finished?F('brew_trainer.sub_full','{w}g poured against a 225.0g recipe · stopped at {t}',{w:S.w.toFixed(1),t:mmss(S.t)})
    :F('brew_trainer.sub_partial','{w}g poured against a 225.0g recipe · stopped at {t} of 2:00',{w:S.w.toFixed(1),t:mmss(S.t)});
  $('resBody').innerHTML=rows.map(e=>{
    const [cls,txt]=tagFor(e);
    const nm=e.st.kind==='wait'?F('brew_trainer.rest_row','Rest {s}s',{s:e.st.dur}):e.st.label;
    const tg=e.st.kind==='wait'?'0g':e.st.add.toFixed(1)+'g';
    if(!e.reached) return `<tr class="bt-off"><td>${nm}</td><td>${tg}</td><td>—</td><td>—</td><td><span class="bt-tag bt-${cls}">${txt}</span></td></tr>`;
    const fl=e.st.kind==='wait'?(e.actual>0.8?e.avg.toFixed(1):'—'):e.avg.toFixed(1)+' / '+e.tgtFlow.toFixed(1);
    return `<tr><td>${nm}</td><td>${tg}</td><td>${e.actual.toFixed(1)}g</td><td>${fl}</td><td><span class="bt-tag bt-${cls}">${txt}</span></td></tr>`;
  }).join('');
  $('impactBody').innerHTML=impact(rows).map(p=>'<p>'+p+'</p>').join('');
  $('sheet').classList.remove('bt-hidden');
}

/* ============ brew impact ============ */
function impact(rows){
  const out=[];
  const total=S.w, dTot=total-TOTAL_W, dPct=(dTot/TOTAL_W)*100;
  const bloom=rows[0], p1=rows[2], p2=rows[4];
  const leaked=rows[1].actual+rows[3].actual+rows[5].actual;
  const finished=S.t>=TOTAL_T-0.2;

  if(!finished){
    const nx=rows.find(e=>!e.complete);
    out.push(F('brew_trainer.impact_stopped_html','You stopped at <b>{t}</b>, part-way through {step}. Only finished steps are scored. Run the full 2:00 to see the whole picture.',{t:mmss(S.t),step:nx?(nx.st.kind==='wait'?a_rest():nx.st.label):T('brew_trainer.the_recipe','the recipe')}));
    if(!bloom.complete) return out;
  }

  if(finished){
    if(Math.abs(dPct)<=2)
      out.push(F('brew_trainer.impact_total_ok_html','Total water <b>{w}g</b>, on target. Your ratio is right, so the cup should taste the way this recipe intends.',{w:total.toFixed(1)}));
    else if(dTot>0)
      out.push(F('brew_trainer.impact_total_over_html','Total water <b>{w}g</b>, <b>{d}g over</b>. Same coffee, more water: weaker and thinner, with less sweetness.',{w:total.toFixed(1),d:dTot.toFixed(1)}));
    else
      out.push(F('brew_trainer.impact_total_under_html','Total water <b>{w}g</b>, <b>{d}g under</b>. Less water on the same coffee: stronger and heavier, with sharper acidity and a short finish.',{w:total.toFixed(1),d:Math.abs(dTot).toFixed(1)}));
  }

  const bE=bloom.errPct;
  if(bloom.complete){
    if(Math.abs(bE)<=5)
      out.push(F('brew_trainer.impact_bloom_ok_html','Bloom <b>{w}g</b>, on target. The grounds wet evenly and the gas escapes before the main pours.',{w:bloom.actual.toFixed(1)}));
    else if(bE<0)
      out.push(F('brew_trainer.impact_bloom_short_html','Bloom <b>{w}g</b>, <b>{p}% short</b>. Some grounds stayed dry, and water skips past dry patches later. That part of your coffee never extracts, which tastes sour and thin.',{w:bloom.actual.toFixed(1),p:Math.abs(bE).toFixed(0)}));
    else
      out.push(F('brew_trainer.impact_bloom_over_html','Bloom <b>{w}g</b>, <b>{p}% over</b>. The brew starts draining before the gas is out, so the rest of the pours run fast and the cup falls flat.',{w:bloom.actual.toFixed(1),p:bE.toFixed(0)}));
  }

  const pours=[bloom,p1,p2].filter(e=>e.complete&&e.avg);
  const fast=pours.filter(e=>e.avg-e.tgtFlow>0.9), slow=pours.filter(e=>e.avg-e.tgtFlow<-0.9);
  const names=l=>l.length===1?`<b>${l[0].st.label}</b>`
    :F('brew_trainer.list_and','{a} and {b}',{a:l.slice(0,-1).map(e=>`<b>${e.st.label}</b>`).join(', '),b:`<b>${l[l.length-1].st.label}</b>`});
  const rates=l=>l.map(e=>F('brew_trainer.rate_vs','{a} vs {b}',{a:e.avg.toFixed(1),b:e.tgtFlow.toFixed(1)})).join(', ')+' g/s';
  if(fast.length)
    out.push(F('brew_trainer.impact_fast_html','You poured too fast in {steps} ({rates}). Hard pouring pushes fine particles down into the filter, which slows the drain and turns the end of the cup bitter.',{steps:names(fast),rates:rates(fast)}));
  if(slow.length)
    out.push(F('brew_trainer.impact_slow_html','You poured too slowly in {steps} ({rates}). That is too gentle to mix the bed, so the outer grounds under-extract while the middle over-extracts: sour and dull in the same sip.',{steps:names(slow),rates:rates(slow)}));

  let worst=null;
  for(const e of [bloom,p1,p2]){
    if(!e.complete||!e.avg) continue;
    const core=S.hist.filter(x=>x.t>e.st.t0+e.st.dur*0.15&&x.t<e.st.t1-e.st.dur*0.1&&x.f>e.tgtFlow*0.35).map(x=>x.f);
    if(core.length<8) continue;
    const hi=Math.max(...core), lo=Math.min(...core);
    const rel=(hi-lo)/Math.max(0.5,e.tgtFlow);
    if(!worst||rel>worst.rel) worst={rel,hi,lo,name:e.st.label};
  }
  if(worst){
    if(worst.rel>0.45)
      out.push(F('brew_trainer.impact_uneven_html','Your flow in <b>{step}</b> jumped between <b>{lo}</b> and <b>{hi} g/s</b>. Hold one steady rate instead. An uneven pour is hard to repeat tomorrow.',{step:worst.name,lo:worst.lo.toFixed(1),hi:worst.hi.toFixed(1)}));
    else if(worst.rel<0.18&&pours.length>=2&&!fast.length&&!slow.length)
      out.push(T('brew_trainer.impact_steady','Your flow stayed steady through every pour. That is what makes a recipe repeatable: change one thing tomorrow and you will know it was that thing.'));
  }

  if(leaked>2)
    out.push(F('brew_trainer.impact_leaked_html','You poured <b>{w}g</b> during the rests. The bed needs that time to drain, and extra water there shifts the timing of every step after it.',{w:leaked.toFixed(1)}));

  if(p2.complete&&Math.abs(p2.errPct)>12)
    out.push(T('brew_trainer.impact_fix_pour2_html','Fix Pour 2 first. It is <b>44%</b> of the water and sets the final brew time, so it moves the cup more than anything else here.'));

  return out;
}
function a_rest(){ return T('brew_trainer.a_rest','a rest'); }

/* init */
reset(); renderSteps(0); renderTimeAxis(RECIPE[0]);
setTimeout(sizeCanvas,80); window.addEventListener('load',sizeCanvas);
}
if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot);
else boot();
document.addEventListener('shopify:section:load',boot);
})();